const NETWORK_ERROR_MESSAGE = "Check your internet connection and try again in a minute.";

export function friendlyErrorMessage(error) {
  const raw = error?.message || String(error || "");
  const lower = raw.toLowerCase();

  if (
    lower.includes("failed to fetch") ||
    lower.includes("networkerror") ||
    lower.includes("network request failed") ||
    lower.includes("load failed") ||
    lower.includes("err_internet_disconnected") ||
    lower.includes("err_connection")
  ) {
    return NETWORK_ERROR_MESSAGE;
  }

  return raw || NETWORK_ERROR_MESSAGE;
}
